<template>
  <div>
    <component :is="form.component" />
  </div>
</template>
<script>
import { FormFlowMixin } from '@/modules/core/form/mixins/FormFlowMixin';
import ToolsModal from '@/modules/admin/components/stateful/resource/ToolsModal.vue';
import Lang from '@/modules/core/app/services/Lang';
import { ComponentForm } from '@/modules/admin/models/ComponentForm';
import { FormComputedValueMixin } from '@/modules/core/form/mixins/FormComputedValueMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ToolItemModal',
  mixins: [FormFlowMixin, FormComputedValueMixin],
  props: {
    value: ComponentForm
  },
  methods: {
    getCancelText() {
      return Lang.t('ui.tools');
    },
    cancel() {
      this.flow(ToolsModal);
    }
  }
};
</script>
